import { create } from "zustand";

import { DEFAULT_ANALYZE_TAB } from "../constants";
import { AnalyzeTab } from "../types";

interface AnalyzeStore {
    tabId: AnalyzeTab;
    setTabId: (tabId: AnalyzeTab) => void;
}

export const useAnalyzeStore = create<AnalyzeStore>((set) => ({
    tabId: DEFAULT_ANALYZE_TAB,
    setTabId: (tabId) => set({ tabId }),
}));
